const {
  REACT_APP_BASE_PROD_CARD_URL,
  REACT_APP_BASE_STAGE_CARD_URL,
  REACT_APP_BASE_PROD_CALLS_URL,
  REACT_APP_BASE_STAGE_CALLS_URL,
} = process.env;

export const isLeader = false;
// window.location.href.startsWith(`${REACT_APP_BASE_PROD_CALLS_URL}/leader`) ||
// window.location.href.startsWith(`${REACT_APP_BASE_STAGE_CALLS_URL}/leader`);

export const isCalls =
  window.location.href.startsWith(`${REACT_APP_BASE_PROD_CALLS_URL}/assistant`) ||
  window.location.href.startsWith(`${REACT_APP_BASE_STAGE_CALLS_URL}/assistant`);

export const isBC =
  window.location.href.startsWith(REACT_APP_BASE_PROD_CARD_URL) ||
  window.location.href.startsWith(REACT_APP_BASE_STAGE_CARD_URL);

export const MAIN_COLOR = isLeader ? '#6c20e4' : '#05a1fc';
